import React, { PureComponent } from "react";
import Cookies from "universal-cookie";
import { withTranslation } from "react-i18next";
import { Collapse, Button,
  ButtonToolbar, Modal } from "reactstrap";
import DownIcon from "mdi-react/ChevronDownIcon";
import axios from "axios";
import Util from "../../Common/util";
import API from "../../Common/api";
import {addAnalytics} from '../../Common/analytics';

const cookies = new Cookies(window.document.cookies);
var url = window.location.hostname;
var port = window.location.port;
var location = ""

class TopbarLanguage extends PureComponent {
  constructor() {
    super();
    this.state = {
      collapse: false,
      selectedLocation: null,
      userLocations: [],
      authtoken: null,
      isHovered: false,
      locationModal: false,
      selectedLocations: "",
      zoomLevel: 1,
    };
    this.deleteCookie = this.deleteCookie.bind(this);

    //this.accessCookie();
  }

  redirectToJira =()=>{
        addAnalytics('Create Jira', 'Redirect to jira');
        window.open('https://swiggy.atlassian.net/servicedesk/customer/portal/1035','_blank');
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }
    locationToggle = () =>{
    this.setState((prevState) => ({ locationModal: !prevState.locationModal }));
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  zoneDropdown = () => {
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/cycle_count/cycleCountParameters/v1/", { param: payload })
      .then((response) => {
        console.log("Zone - TopBar", response);
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          alert("Session Expired. Please Login Again");
          window.location.href =
            "http://" + window.location.hostname + ":" + window.location.port;
        }
      });
  };

  createCookie = (cookieName, cookieValue, daysToExpire) => {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  };

 deleteCookie = (name) => {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path="+window.location.pathname;
  };

  setCookie = (name, value, days)=> {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path="+window.location.pathname;
}

  fetchLocation = () =>{
    var encryptedLoc = this.getCookie("userLocations");
     var locationData = encryptedLoc.split("$$##!");
             this.setState({
                location_list: locationData,
              });
              this.locationToggle();
             
  }

  componentDidMount() {
    this.detectZoom();
    // Add event listener to track zoom level changes
    window.addEventListener('resize', this.detectZoom);
  }


   componentWillUnmount() {
    // Clean up event listener when component is unmounted
    window.removeEventListener('resize', this.detectZoom);
  }

   detectZoom = () => {
    const zoom = window.devicePixelRatio || 1; // Get zoom level
    this.setState({ zoomLevel: zoom });
  };

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("userLocations").split("-");
    var username = this.accessCookie("userLocations");

    var location = cookies.get("userLocations");
    var authtoken = cookies.get("token");

    this.setState({
      userName: cookieUsername,
      authtoken: authtoken,
    });

    /*const userLocations = JSON.parse(cookies.get('userLocations') || JSON.stringify([])) || JSON.stringify(['bhi']));*/
    /*console.log(JSON.parse(cookies.get('userLocations')));*/
    const userLocations =
      /*JSON.parse(JSON.stringify(location) || JSON.stringify(['bhi']));*/ cookieUsername;

    if (authtoken.indexOf(":") > -1) {
      this.deleteCookie("selectedLocation");
      const splitted_locations = authtoken.split(":")[1];

      if (
        cookies.get("selectedLocation") === null ||
        cookies.get("selectedLocation") === undefined
      ) {
        this.createCookie("selectedLocation", splitted_locations);
      }
    }

    var selectedLocation = cookies.get("selectedLocation");

    this.setState(
      {
        selectedLocation,
        userLocations,
      },
      () => {
        /*this.zoneDropdown()*/
      }
    );
  }

   handleMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false });
  };

  toggle = () => {
    this.setState((prevState) => ({ collapse: !prevState.collapse }));
  };

/*  changeLocation = (location) => {
    this.setState(
      {
        selectedLocation: location,
        collapse: false,
      },
      () => {}
    );

    window.location.reload();
  };
*/

  changeLocation = (e) => {
    /*this.setState({
      locationNotSelected: false,
      selectedLocations: e.target.value,
    });*/
    location = e.target.value
    this.setState(
      {
        selectedLocations: e.target.value,
        locationNotSelected: false,
      },
      () => {console.log("verify loc",this.state.selectedLocations)}
    );

    console.log(this.state.selectedLocations)
  };

   onLocation = ()=> {
    console.log("verify loc", location)
    if(location === "" || location === undefined || location === null ){
      this.setState({
        locationNotSelected: true
      });

      return false;
    }

      cookies.remove('selectedLocation', { path: '/' });
      cookies.remove('token', { path: '/' });
    
    //var previous_token = this.getCookie("token").split(':');
    //console.log("previous_token", previous_token)
    
    //return false;

    /*this.deleteCookie('selectedLocation');

    cookies.remove('selectedLocation');
    cookies.remove('direct_putaway_flag');
    cookies.remove('userMenu');*/
    //cookies.remove("token")

    const payload = {
      location: location,
    };
  
    API.post('/auth/users/location/activate', { param: payload })
      .then((response) => {
        console.log(response.data.direct_putaway)
         this.setState({
          locationModal: false,
          selectedLocation: location
        })



        //cookies.set("selectedLocation", location)
         //token = this.getCookie("token") + ":" + location
        //this.setCookie("selectedLocation", location);
        /* var token = previous_token[0] + ":" + location;
         console.log('Token',token);*/
         
        
        //this.setCookie("token", token);
        //this.setCookie("token", token, 1);
       
        //addAnalytics('Login', 'Location Selection', location);
        //token = cookies.get("token") + ":" + location;
         /*cookies.set('selectedLocation', location, { path: '/' });
         cookies.set('direct_putaway_flag', response.data.direct_putaway, { path: '/' });
        cookies.set('userMenu', response.data.userMenu, { path: '/' });*/
        /*cookies.set("token", token);
        cookies.set("selectedLocation", location);
        cookies.set("direct_putaway_flag", response.data.direct_putaway);
        cookies.set("userMenu", response.data.userMenu);*/
        //this.locationToggle();
       
        //window.location.reload();

        //window.location.href = window.location.protocol+"//" + url + ":" + port + "/dashboard_default";
      }).catch(function (error) {});
  }


  render() {
    const { selectedLocation, userLocations, collapse, handleMouseEnter,  handleMouseLeave, isHovered, locationModal, zoomLevel} = this.state;
     let locationTextSize = "16px";

     if (zoomLevel >= 1.5) {
      locationTextSize = '12px';
      
    } else if (zoomLevel >= 1.25) {
      locationTextSize = "14px";
    } else if (zoomLevel > 1.1) {
      locationTextSize = '16px'
    }

    return (
      <div style={{width: '70%', float: 'left'}} className="topbar__collapse topbar__collapse--language">
      <div style={{width: '60%', float: 'left', textAlign: 'right'}}>
                    <Button
                    className="btn-sm button_enable "
  
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      marginTop: 8,
                      display: 'none'
                    }}
                    id="button_enable"
                    onClick={() => this.fetchLocation()}
                  >
                   
                      
                       <span style={{color: 'black'}} className="text">Change Location</span>

                  </Button>
     
                  <Button
                    /*className="btn-sm button_enable "*/
                    className={isHovered ? 'button hovered' : 'button'}
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      marginTop: 8
                    }}
                    id="button_enable"
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}

                    onClick={() => this.redirectToJira()}
                  >
                   
                      
                      {isHovered && <span style={{color: 'black'}} className="text">Create Ticket</span>}
                  
                    {/*Create Ticket*/}

                     <img
                    src={require("../../../images/fa-square.png")}
                    style={{ width: "16px", height: "16px", marginLeft: 12 }}
                  ></img>
                  </Button>
                
      </div>
      <div style={{width: '40%', float: 'left', textAlign: 'right'}}>
        <button className="topbar__btn" style={{display: 'initial'}} type="button" onClick={this.toggle}>
          <span className="topbar__language-btn-title">
            <span style={{ fontSize: locationTextSize, fontWeight: 'bold', marginTop: 16}}>{this.state.selectedLocation}</span>
          </span>
          {/*<DownIcon className="topbar__icon" />*/}
        </button>
        </div>
        {/*  {collapse && <button className="topbar__back" type="button" onClick={this.toggle} />}*/}
        {/*<Collapse
          isOpen={collapse}
          className="topbar__collapse-content topbar__collapse-content--language"
        >
          {userLocations && userLocations.map((location, index) => (
            <button
              key={index}
              className="topbar__language-btn"
              type="button"
              onClick={() => this.changeLocation(location)}
            >
              <span className="topbar__language-btn-title">
                <span>{location}</span>
              </span>
            </button>
          ))}
        </Collapse>*/}


         <Modal isOpen={locationModal} toggle={this.locationToggle}>
          <div className="modal__header">
            <button
              className="fa fa-times modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.locationToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <div>
             <img
                    src={require("../../../images/login_map.svg")}
                    style={{ width: "40%" }}
                  ></img>
              </div>

               <div className="form__form-group-field" style={{marginTop: 20, flexDirection: 'column'}}>
                  <div style={{width: '78%', margin: 'auto', textAlign: 'left'}}>
                  <label style={{textAlign: 'left'}}> Choose a location </label>
                  </div>
                  <div>
                  <select
                    className="form-control select_style"
                    style={{ fontSize: 13, width: 300, height: 40}}
                    onChange={this.changeLocation}
                    /*onKeyDown={(e) => this._handleKeyDown1(e)}*/
                  >
                    <option value="">Select Location</option>
                    {this.state.location_list &&
                      this.state.location_list.length > 0 &&
                      this.state.location_list.map((location_list) => {
                        return (
                          <option value={location_list}>
                            {" "}
                            {location_list}
                          </option>
                        );
                      })}
                  </select>
                  </div>
                  
                </div>

           
          </div>
          <ButtonToolbar className="modal__footer">
            
            <Button
                className="btn-lg button_enable "
                
                onClick={this.onLocation}
              >
                Proceed
              </Button>
          </ButtonToolbar>
        </Modal>


      </div>
    );
  }
}

export default withTranslation("common")(TopbarLanguage);
